<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.795 8.852c.45 0 .815.364.815.814v2.814l.601-.6a.816.816 0 011.153 1.153l-1.754 1.753v4.426h.779a.815.815 0 110 1.63h-3.188a.816.816 0 010-1.63h.779v-6.02l-1.753-1.753a.816.816 0 010-1.153l.061-.056a.815.815 0 011.091.056l.6.601v-1.22c0-.45.366-.815.816-.815z"/><path d="M11.795 3.273c2.65 0 4.48 1.92 4.76 4.25a4.8 4.8 0 013.207 5.016 4.802 4.802 0 01-4.768 4.317l-.011.001h-.797a.815.815 0 010-1.63h.798a3.172 3.172 0 003.156-2.851 3.17 3.17 0 00-2.524-3.425.816.816 0 01-.652-.799c0-1.797-1.274-3.249-3.169-3.249s-3.169 1.452-3.169 3.25a.815.815 0 01-.58.78l-.07.017a3.172 3.172 0 00.635 6.277h.793a.815.815 0 010 1.63h-.8A4.803 4.803 0 014.75 9.216a4.801 4.801 0 012.285-1.691c.28-2.332 2.11-4.252 4.761-4.252z"/></svg>

</template>


<script>

  export default {"name":"icon-0fdde55e5a1cedb7168d82f877ee27ed"}

</script>